import { useAuthRestApi } from '../common';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { Observable } from 'rxjs';
import { IChannelWithBlock, IOrgChatApi } from '@vivli/features/chat/infrastructure/interface';

export const useOrgChatApi = (): IOrgChatApi => {
    const config = useAppConfigContext();
    const { handleGet } = useAuthRestApi({
        endpoint: `${config?.chatUri}api`,
        overrideOptions: { retryCalls: '1', errorHandler: null }
    });
    const getChatOrganizationChannels = (dataRequestId: string): Observable<IChannelWithBlock> => {
        return handleGet<IChannelWithBlock>(`/dataRequests/${dataRequestId}/myorgchannels`);
    };

    return {
        getChatOrganizationChannels
    };
};
